import React from "react"
import { CardTitle } from "reactstrap"
import ReactApexChart from "react-apexcharts/dist/react-apexcharts.cjs.js"

const ApexChart = ReactApexChart.default || ReactApexChart

const Barchart = ({ series }) => {
  const backDates = Array.from({ length: 21 }, (_, i) => {
    const d = new Date()
    d.setDate(d.getDate() - i)
    return d.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
    })
  })

  const options = {
    chart: {
      toolbar: {
        show: true,
      },
    },
    theme: {
      mode: 'light',
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "60%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    colors: ["#6366f1", "#f59e0b", "#10b981"],
    xaxis: {
      categories: backDates.reverse(),
      labels: {
        style: {
          colors: "#64748b"
        }
      }
    },
    yaxis: {
      title: {
        text: "Shipments",
        style: {
          color: "#64748b"
        }
      },
      labels: {
        style: {
          colors: "#64748b"
        }
      }
    },
    grid: {
      borderColor: "rgba(0, 0, 0, 0.05)",
    },
    fill: {
      opacity: 0.9,
    },
    tooltip: {
      theme: 'light',
      y: {
        formatter: val => val + " Shipments",
      },
    },
  }

  return (
    <>
      <CardTitle className="mb-4"> Last 21 Days Status </CardTitle>
      <ApexChart
        options={options}
        series={series}
        type="bar"
        height={350}
      />
    </>
  )
}

export default Barchart
